import descuentoHelper from '@/helpers/descuentosHelper.js'
import store from '@/store'
import { imagenCard } from '@/helpers/imagenTienda.js'

const S4 = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

const mapItemToCartItem = (item) => {
  // Construir GrupoDescuento correctamente desde Descuentos si es necesario
  let grupoDescuentoFinal = item.GrupoDescuento

  // Si el array Descuentos está vacío o el GrupoDescuento no tiene TipoDescuento,
  // buscar en el store global de descuentos
  if (item.GrupoDescuento && !item.GrupoDescuento.TipoDescuento) {
    // Obtener descuentos del store global
    const descuentosGlobales = store.getters['App/data']?.Descuentos || []

    // Buscar el descuento que corresponde a este grupo con Cantidad > 0
    const descuentoGrupo = descuentosGlobales.find(d =>
      d.GrupoId === item.GrupoDescuento.GrupoId && d.Cantidad > 0
    )

    if (descuentoGrupo) {
      // Construir el GrupoDescuento con toda la información
      // TipoDescuento (P/I/C) indica el MÉTODO de cálculo del descuento
      grupoDescuentoFinal = {
        GrupoId: descuentoGrupo.GrupoId,
        GrupoNombre: descuentoGrupo.GrupoNombre || '',
        Cantidad: descuentoGrupo.Cantidad,
        PorcentajeDesct: descuentoGrupo.PorcentajeDesct,
        TipoDescuento: descuentoGrupo.TipoDescuento // Método: P=Porcentaje, I=Importe, C=Combo
      }

      // También asignar todos los descuentos del grupo al item para futuras referencias
      item.Descuentos = descuentosGlobales.filter(d => d.GrupoId === item.GrupoDescuento.GrupoId)
    }
  }

  // Actualizar el item con el GrupoDescuento correcto
  item.GrupoDescuento = grupoDescuentoFinal

  // si no hay descuento, viene el mismo precio
  const discointOrPrice = descuentoHelper.precioConDescuento(item)
  const guid = (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase()
  if (item.esCombinadoCombo) {
    return {
      _id: guid,
      esCombinado: true,
      productId: item.id,
      nombre: item.nombre,
      cant: item.cant,
      precio: item.PrecioUnitario || item.precio || item.totalPrice,
      GrupoDescuento: grupoDescuentoFinal,
      discoint: discointOrPrice,
      descuentoPorProducto: item.Descuentos && item.Descuentos.length > 0,
      descuentoPorGrupo: grupoDescuentoFinal !== null && grupoDescuentoFinal !== undefined,
      descuentoPorGrupoCantidad: grupoDescuentoFinal ? grupoDescuentoFinal.Cantidad > 0 : false,
      observaciones: item.obs,
      img: imagenCard(item.detalle.srcImg),
      productos: item.items.map((element) => {
        return {
          id: element.id,
          cant: element.cant,
          nombre: element.name,
          precio: element.PrecioUnitario || element.precio || element.totalPrice,
          discoint: descuentoHelper.precioConDescuento(element),
          total: element.cant * element.PrecioUnitario,
          Parent: guid
        }
      })
    }
  } else if (item.esEstatico) {
    return {
      _id: guid,
      esEstatico: true,
      productId: item.id,
      nombre: item.nombre,
      cant: item.cant,
      GrupoDescuento: grupoDescuentoFinal,
      descuentoPorProducto: item.Descuentos && item.Descuentos.length > 0,
      precio: item.PrecioUnitario || item.precio || item.totalPrice,
      discoint: discointOrPrice,
      observaciones: item.obs,
      img: imagenCard(item.detalle.srcImg),
      descuentoPorGrupo: grupoDescuentoFinal !== null && grupoDescuentoFinal !== undefined,
      descuentoPorGrupoCantidad: grupoDescuentoFinal ? grupoDescuentoFinal.Cantidad > 0 : false,
      productos: item.childs.map((element) => {
        return {
          id: element.id,
          cant: element.CantMinima,
          nombre: element.nombre,
          precio: 0,
          total: 0,
          Parent: guid
        }
      })
    }
  } else {
    return {
      _id: guid,
      esCombinado: false,
      productId: item.id,
      nombre: item.nombre,
      GrupoDescuento: grupoDescuentoFinal,
      descuentoPorProducto: item.Descuentos && item.Descuentos.length > 0,
      descuentoPorGrupo: grupoDescuentoFinal !== null && grupoDescuentoFinal !== undefined,
      descuentoPorGrupoCantidad: grupoDescuentoFinal ? grupoDescuentoFinal.Cantidad > 0 : false,
      cant: item.cant,
      precio: item.PrecioUnitario || item.precio || item.totalPrice,
      discoint: discointOrPrice,
      img: imagenCard(item.detalle.srcImg)
    }
  }
}

export default mapItemToCartItem
